import React from 'react';

import { Col, Row } from '@zillow/zrs-comet';
import { Text } from '@zillow/constellation';

import UnitsMF from 'app/shared/components/postingPath/UnitsMF';
import { StyledHiddenAnchor } from 'app/shared/StyledComponents/StyledComponents';

import '../utils.scss';

const noop = () => {};

const UnitsSection = ({
    formData,
    isMobile,
    isInputFormDisabled,
    canEditTourOverwrite,
}) => (
    <div className="UnitsSection">
        <Row>
            <Col>
                <Text className="PostingPath-module-title" fontType="h2">
                    Manage units
                </Text>
            </Col>
        </Row>
        <StyledHiddenAnchor id="units" />
        <UnitsMF
            canAddUnits={false}
            canEditTourOverwrite={canEditTourOverwrite}
            floorPlanIndex={null}
            floorplans={formData.floorplans}
            formData={formData}
            isDisabled={formData.vaultware || isInputFormDisabled}
            isMobile={isMobile}
            onAddUnit={noop}
            onRemoveUnit={noop}
            onToggleActive={noop}
            units={formData.units}
            updateFormData={noop}
            updateParentFloorPlanPrice={noop}
            validateFloorPlan={noop}
            updateStatusMessage={noop}
        />
    </div>
);

export default UnitsSection;
